export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "container_service": {
            "started_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de inicio"])},
            "finished_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fecha de fin"])},
            "finished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finalizado"])},
            "container_schedule_technician_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Técnico"])}
          }
        }
      },
      "en": {
        "model": {
          "container_service": {
            "started_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Started at"])},
            "finished_at": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finished at"])},
            "finished": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Finished"])},
            "container_schedule_technician_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Technician"])}
          }
        }
      }
    }
  })
}